export default __webpack_public_path__ + "static/media/Gender_Non_Binary.e7420941.svg";